module.exports = __webpack_public_path__ + "static/media/whatsappBlastDesktop.b99bbd07.png";